import { actionTypes } from '../constants';

export const newConfigPageReset = () => ({
  type: actionTypes.newConfigPageReset,
});
